import { Appointment, SUBJECT_KEYS } from "@elixir/types";
import sendMrLink from "../../../../apis/parchi/send-mr-link";
import { ReactComponent as FilesRegularIcon } from "../../../../assets/icons/font-awesome/files-regular.svg";
import { notification } from "antd";
import {
  isAccessAvailable,
  showAccessDeniedError,
} from "../../../../utils/bridges/methods";
import { ChipWithTooltip } from "ui";

const RequestMedicalRecords = ({
  apt,
  className = "",
  type,
}: {
  apt: Appointment;
  className?: string;
  type?: "primary" | "secondary";
}) => {
  const { patient_oid } = apt;
  return (
    <ChipWithTooltip
      onClick={async () => {
        const isRequestMedicalRecordsAllowed = isAccessAvailable(
          SUBJECT_KEYS.CAN_REQUEST_RECORDS
        );
        if (isRequestMedicalRecordsAllowed) {
          const response = await sendMrLink({ patientOid: patient_oid });
          if (response.success) {
            notification.success({
              message: "Success",
              description: "Medical records requested successfully!",
              placement: "bottomRight",
            });
          } else {
            notification.error({
              message: "Error",
              description: "Failed to request medical records.",
              placement: "bottomRight",
            });
          }
        } else {
          showAccessDeniedError();
        }
      }}
      className={`h-32 flex-1 ${className}`}
      icon={<FilesRegularIcon className="dr-min-w-14 dr-h-14" />}
      title="Medical Records"
      tooltipText="Request Medical Records"
      type={type}
    />
  );
};

export default RequestMedicalRecords;
